export default __webpack_public_path__ + "static/media/Eye_6_F_C4.0710034b.svg";